module.exports = __webpack_public_path__ + "img/section3Logo1.96bdca3a.webp";